module.exports = __webpack_public_path__ + "img/CurrencyNgn-Active.3010a394.svg";